export { default as ExecutiveFunctions } from './ExecutiveFunctions';

export const PATH = '/executive-functions';
